import React, {ReactElement} from "react";
import {Dialog} from "@headlessui/react";
import {FormattedMessage} from "react-intl";
import {useAppDispatch, useAppSelector} from "lib/redux/hooks";
import {ReactComponent as CloseIcon} from "components/Icons/close.svg";
import {SecondaryButton} from "components/UIComponents/SecondaryButton";
import {PrimaryButton} from "components/UIComponents/PrimaryButton";
import {menuEditorActions, menuEditorSelectors} from "./editorSlice";

export interface DeletePageModalProps {

}

export function DeletePageModal(props: DeletePageModalProps): ReactElement {
    const active = useAppSelector(menuEditorSelectors.deletePopoverActive);
    const page = useAppSelector(menuEditorSelectors.deletePopoverPage);

    const dispatch = useAppDispatch();
    const closeModal = () => dispatch(menuEditorActions.closeDeletePopover());
    const deletePage = () => {
        if (page == null) {
            return;
        }

        dispatch(menuEditorActions.deletePage(page));
        dispatch(menuEditorActions.closeDeletePopover());
    };

    return (
        <Dialog
            open={active}
            onClose={closeModal}
            className="fixed z-modal inset-0 overflow-y-auto"
        >
            <div className="flex items-center justify-center min-h-screen">
                <Dialog.Overlay className="fixed inset-0 bg-text opacity-60"/>

                <div className="relative flex flex-col w-1/3 max-w-sm mx-auto
                                py-6 px-5 bg-white rounded-lg">

                    <div className="flex-none flex items-center">
                        <Dialog.Title className="flex-auto font-barlow text-lg font-semibold">
                            <FormattedMessage id="editor.deletepage.title"/>
                        </Dialog.Title>
                        <button className="flex-none"
                                onClick={closeModal}>
                            <CloseIcon className="inline-block w-5 h-5" />
                        </button>
                    </div>

                    <div className="flex-auto flex flex-col">
                        <div className="flex-auto pt-5 pb-10">
                            <p><FormattedMessage id="editor.deletepage.text" /></p>
                        </div>


                        <div className="flex-none flex gap-2 justify-end items-center">
                            <SecondaryButton onClick={closeModal}>
                                <FormattedMessage id="editor.deletepage.cancel" />
                            </SecondaryButton>

                            <PrimaryButton onClick={deletePage}>
                                <FormattedMessage id="editor.deletepage.delete" />
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}